import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'pwell-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'PartneredWell',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: '',
  email: 'support@partneredwell.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/pwell/index.js